import {
  OFFERS_LIST_SUCCESS,
  OFFERS_INFO_SUCCESS,
  OFFERS_UPDATE_SUCCESS,
  OFFERS_STATUS_SUCCESS,
  CLEAR_OFFERS_INFO,
} from "../actionTypes/offers";
import {
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  INIT_URL,
  ON_SHOW_MESSAGE,
} from "../actionTypes/common";
import { userSignOut } from "./auth";
import axiosHttp from "../services/axiosCommon";

export const getOffersList = (queryInfo = {}) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const params = {
      page: queryInfo.page || 1,
      size: queryInfo.size || 10,
      ...(queryInfo.status && { status: queryInfo.status }),
      ...(queryInfo.level && { level: queryInfo.level }),
      ...(queryInfo.merchant && { merchant: queryInfo.merchant }),
      ...(queryInfo.search && { search: queryInfo.search }),
    };
    const result = await axiosHttp.get("/v1/admin/offers", { params });
    const { data } = result;
    if (!data.status && data.code !== 200) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({
      type: INIT_URL,
      payload: "/offers/list",
    });
    dispatch({
      type: OFFERS_LIST_SUCCESS,
      payload: {
        data: data.results?.data || [],
        count: data.results?.count || 0,
        pages: data.results?.pages || 0,
        queryInfo: data.results?.queryInfo || { page: 1, size: 10 },
      },
    });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const getOfferInfo = (offerId) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.get(`/v1/admin/offers/${offerId}`);
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({ type: ON_HIDE_LOADER });
    dispatch({
      type: OFFERS_INFO_SUCCESS,
      payload: data.results,
    });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const setOfferInfo = (info) => async (dispatch) => {
  dispatch({
    type: OFFERS_INFO_SUCCESS,
    payload: info,
  });
};

export const createOffer = (payload) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.post("/v1/admin/offers", payload);
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({ type: ON_SHOW_MESSAGE, payload: data });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const updateOffer = (offerId, payload) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.put(`/v1/admin/offers/${offerId}`, payload);
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({ type: OFFERS_UPDATE_SUCCESS, payload: data.results });
    dispatch({ type: ON_SHOW_MESSAGE, payload: data });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const patchOfferStatus = (offerId, status) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.patch(`/v1/admin/offers/${offerId}/status`, {
      status,
    });
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({ type: OFFERS_STATUS_SUCCESS, payload: data.results });
    dispatch({ type: ON_SHOW_MESSAGE, payload: data });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const deleteOffer = (infoData) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const { id } = infoData;
    const result = await axiosHttp.delete(`/v1/admin/offers/${id}`);
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({ type: ON_SHOW_MESSAGE, payload: data });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const clearOfferInfo = () => async (dispatch) => {
  dispatch({ type: CLEAR_OFFERS_INFO });
};
